import styled from 'styled-components';

export const ReadMoreLinkStyled = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 1.7;
  color: #0d96c6;
  transition: color 0.25s ease-in;
  cursor: pointer;

  &:after {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 10px;
    border-top: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #0d96c6;
    transition: border 0.25s ease-in;
  }

  &:hover,
  &:focus {
    color: #053b4e;
    transition: color 0.25s ease-in;
    &:after {
      border-left: 6px solid #053b4e;
      transition: border 0.25s ease-in;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/universal-login/components/ReadMoreLink/styled.js